import script from "./other-works-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./other-works-icon.vue?vue&type=script&setup=true&lang=js"

import "./other-works-icon.vue?vue&type=style&index=0&id=8069e944&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8069e944"]])

export default __exports__